export default __webpack_public_path__ + "images/06781f2cb09a700df1fce830051d4482-anime_small.webp";